import * as React from 'react';

import { storesContext } from 'contexts';

export const useStores = () => {
  const stores = React.useContext(storesContext);
  if (!stores) throw new Error('Store must be provided in top of application');
  return stores;
};
